export default "__VITE_ASSET__D0S6syJK__"